import React from 'react';
import styles from './index.module.less';
import Image from 'next/image';

const UseViewerForInstagramContent = ({ data }: { data: any }) => {
  if (!data) return null;

  return (
    <section className={styles.content}>
      <h2 className={styles.title}>{data.title}</h2>

      <p className={styles.desc}>{data.desc}</p>

      <div className={styles.bottomContainer}>
        {data.cards?.map?.((item: any, index: number) => (
          <>
            <div key={`item-${index}`} className={styles.itemContainer}>
              <div className={styles.title}>{item?.name}</div>
              <p className={styles.desc}>{item?.desc}</p>
            </div>
            <Image
              key={`img-${index}`}
              src={'/images/toolkit/arrow-icon-1.webp'}
              alt=""
              width={40}
              height={35}
              className={styles.arrow}
            />
          </>
        ))}
      </div>
    </section>
  );
};

export default UseViewerForInstagramContent;
